import styled from "styled-components";

export const WarningMsgWrapper = styled.div`
  width: 100%;
  padding: 16px;

  border-radius: 8px;
  background: linear-gradient(0deg, rgba(199, 54, 54, 0.1) 0%, rgba(199, 54, 54, 0.1) 100%), #fff;
`;
